import { startReactRouterView } from './startReactRouterView';
export function wrapCreateRouter(originalCreateRouter) {
    return ((routes, options) => {
        const router = originalCreateRouter(routes, options);
        let location = router.state.location.pathname;
        router.subscribe((routerState) => {
            const newPathname = routerState.location.pathname;
            if (location !== newPathname) {
                startReactRouterView(routerState.matches);
                location = newPathname;
            }
        });
        startReactRouterView(router.state.matches);
        return router;
    });
}
//# sourceMappingURL=createRouter.js.map